import { useEffect, useState } from 'react';
import { useRemixerAudioContext } from '../../../../../hooks';

const useSourceNode = () => {
  const [sourceNode, setSourceNode] = useState<MediaElementAudioSourceNode>();

  const { audioRef, audioContext } = useRemixerAudioContext();

  useEffect(() => {
    if (!audioRef?.current || !audioContext || sourceNode) {
      return;
    }
    try {
      const newSourceNode = new MediaElementAudioSourceNode(audioContext, {
        mediaElement: audioRef.current,
      });
      setSourceNode(newSourceNode);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Could not create MediaElementAudioSourceNode:', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioRef?.current, audioContext, sourceNode]);

  return sourceNode;
};

export default useSourceNode;
